export default __webpack_public_path__ + "img/whatNews4.8e7bb218.jpg";